import { PagedSearch } from '../../../shared/model/paged-search.model';

export class ImageSearchParams extends PagedSearch {
  public FileName: string;
  public RestrictToWebContentImages: boolean;
  public RestrictToWebServerFileImages: boolean;
  public ProfileId: number;
  public WebContentId: number;

  public constructor() {
    super();

    this.FileName = '';
    this.RestrictToWebContentImages = false;
    this.RestrictToWebServerFileImages = false;
    this.ProfileId = 0;
    this.WebContentId = 0;
  }
}
